import Vue from 'vue'
import {
	Vuetify,
	VApp,
	VBtn,
	VCard,
	VDataTable,
	VDataIterator,
	VMenu,
	VExpansionPanel,
	VDialog,
	VDivider,
	VFooter,
	VGrid,
	VIcon,
	VList,
	VNavigationDrawer,
	VProgressLinear,
	VSnackbar,
	VSubheader,
	VTextField,
	VToolbar,
	transitions
} from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import { Ripple } from 'vuetify/es5/directives'

Vue.use(Vuetify, {
	components: {
		VApp,
		VBtn,
		VCard,
		VDataTable,
		VDataIterator,
		VMenu,
		VExpansionPanel,
		VDialog,
		VDivider,
		VFooter,
		VGrid,
		VIcon,
		VList,
		VNavigationDrawer,
		VProgressLinear,
		VSnackbar,
		VSubheader,
		VTextField,
		VToolbar,
		transitions
	},
	directives: {
		Ripple
	},
	theme: {
		accent: '#83b347'
	}
})
